import { render, staticRenderFns } from "./SubwayInfo.vue?vue&type=template&id=220798e6&scoped=true&"
import script from "./SubwayInfo.vue?vue&type=script&lang=js&"
export * from "./SubwayInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220798e6",
  null
  
)

export default component.exports